/** Parse/clamp per-subtopic seed overrides (shared by seed panel + tests). */

export function parseSeedMastery(raw: string): number | undefined {
  if (raw.trim() === '') return undefined
  const n = Number(raw)
  if (Number.isNaN(n)) return undefined
  return Math.min(100, Math.max(0, Math.round(n)))
}

export function parseSeedStabilityDays(raw: string): number | undefined {
  if (raw.trim() === '') return undefined
  const n = Number(raw)
  if (Number.isNaN(n) || n <= 0) return undefined
  return n
}

export function parseSeedDifficulty(raw: string): number | undefined {
  if (raw.trim() === '') return undefined
  const n = Number(raw)
  if (Number.isNaN(n)) return undefined
  return Math.min(10, Math.max(1, n))
}
